import classNames from "classnames";
import React from "react";

interface Props {
  checked: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

const AppSwitch = (props: Props) => {
  const handleClick = React.useCallback(() => {
    if (props.onChange !== undefined) {
      props.onChange.call(null, !props.checked);
    }
  }, [props.checked, props.onChange]);

  return (
    <div className={classNames("AppSwitch", { checked: props.checked })} onClick={handleClick}>
      <div />
    </div>
  );
};

export default AppSwitch;
